// Check if every object in the array
export default function areAllPropertiesNonEmpty(objects: Record<string, any>[]) {
  return objects.every((object) =>
    Object.values(object).every(
      (propertyValue) => propertyValue !== null && propertyValue !== undefined
    )
  );
}
